import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import { Autocomplete, FormControl, TextField, Typography, Dialog, DialogActions, DialogContent, Alert } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Grid from '@mui/material/Grid2';
import CircumIcon from "@klarr-agency/circum-icons-react";
import {  Upload } from 'react-feather';
import { Line } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authApi, formauthApi } from '../../api/api';
import { useSelector } from 'react-redux';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import Toastmessage from "../../components/Toast";
import { logout } from "../../features/auth/AuthSlice";


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function MonthlyScoreCard() {
  const [locationName, setLocationName] = useState(null);
  const [monthYear, setMonthYear] = useState('');
  const [monthYearOption, setMonthYearOption] = useState([]);

  const [isLoading, setIsloading] = useState(false)
  const [documentError, setDocumentError] = useState(null)
  const [locationOption, setLocationOptions] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Progress',
        data: [],
        borderColor: 'orange',
        backgroundColor: 'rgba(255, 165, 0, 0.2)',
        fill: true,
        tension: 0.4,
      },
    ],
  });
  const [rows, setRows] = useState([]); // Store filtered data
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [error, setError] = useState('');
  const [report, setReport] = useState([]);
  const [reportRow, setReportRow] = useState([]);

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  console.log(locationName)
  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
    setDragOver(false);
    setError('');
  };
  const Reupload = () => {
    setDocumentError(null)
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
      setSelectedFile(file);
      setError('');
    } else {
      setError('Please upload an Excel file.');
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    const file = event.dataTransfer.files[0];
    if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
      setSelectedFile(file);
      setError('');
    } else {
      setError('Please upload an Excel file.');
    }
    event.dataTransfer.clearData();
  };

  const handleRemove = () => {
    setSelectedFile(null);
  };

  useEffect(() => {
    if (monthYear) {
      fetchWeek()
      fetchAlluserdata()
    }
  }, [monthYear, locationName])
  useEffect(() => {
    fetchLocation();
    fetcYearMonth()
  }, [])


  // Define fetchLocations separately to reuse it
  const fetcYearMonth = async () => {
    const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
    const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setMonthYearOption(data.month_year);
        setMonthYear(data.month_year?.[0])
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // Define fetchLocations separately to reuse it
  const fetchLocation = async () => {
    const input_token = 'LOCATIONS'; // Replace with your actual token
    const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        const statesArray = data.locations.map(location => ({
          id: location.id,
          locationname: location.location_name, // Match `getOptionLabel`
        }));

        setLocationOptions(statesArray);
        setLocationName(statesArray?.[0])

      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  // Define fetchFirm separately to reuse it
  const fetchWeek = async () => {
    const input_token = 'WEEKLY_OVERALL_REPORT'; // Replace with your actual token
    const apiUrl = 'weekly_overall_report'; // Replace with the actual API endpoint
    const dataInput = {
      login_user_id: userID,
      month_year: monthYear,
      location: locationName?.id
    };


    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        const processedReport = data?.weekly_report?.report.map((entry, index) => ({
          id: index + 1,
          date: entry.date,
          actual_billable_dollars: entry.billable_dollars,
          target_billable: entry.target_billable,
          over_under: entry.over_under,
          percent_complete: entry.percent_complete
        }));

        const labels = data?.weekly_report?.report?.map(item => item.date);
        const dataGraph = data?.weekly_report?.report?.map(item => item.percent_complete);
        generateDynamicData(labels, dataGraph)
        // Add overall values as a new entry
        processedReport.push({
          id: processedReport.length + 1,
          date: "",
          actual_billable_dollars: data.weekly_report.overall_billable_dollars,
          target_billable: data.weekly_report.overall_target_billable,
          over_under: data.weekly_report.overall_over_under,
          percent_complete: data.weekly_report.overall_percent_complete
        });
        setRows(processedReport);
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // Define fetchFirm separately to reuse it
  const fetchAlluserdata = async () => {
    const input_token = 'INDIVIDUAL_PERCENT_COMPLETE_BY_WEEK'; // Replace with your actual token
    const apiUrl = 'individual_percent_complete_by_week'; // Replace with the actual API endpoint
    const dataInput = {
      login_user_id: userID,
      month_year: monthYear,
      location: locationName?.id
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {

        const report = Object.entries(data?.header?.[0] || {}).map(([field, headerName]) => {
          if (field === "name") {
            return {
              field,
              headerName,
              flex: 1,
              renderCell: (params) => (
                <p
                  style={{ fontWeight: 'bold', cursor: 'pointer', color: 'var(--primary-color)' }}
                  onClick={() => handleClickView(`${params.row.initial}`, `${params.row.name}`)}
                >
                  {params.value}
                </p>
              ),
            };
          } else if (field.startsWith("week_")) {
            return {
              field,
              headerName,
              flex: 0.5,
              renderCell: (params) => {
                const percentage = parseFloat(params.value);
                let color = "#048A08";
                if (percentage > 95) {
                  color = "#048A08";
                } else if (percentage > 90) {
                  color = "#3570FF";
                } else if (percentage > 80) {
                  color = "#FF7B00";
                } else {
                  color = "#FF1800";
                }
                return <span style={{ color }}>{params.value}%</span>;
              },
            };
          } else if (field === "mtd") {
            return {
              field,
              headerName,
              flex: 0.5,
              renderCell: (params) => {
                const percentage = parseFloat(params.value);
                let color = "#048A08";
                if (percentage > 95) {
                  color = "#048A08";
                } else if (percentage > 90) {
                  color = "#3570FF";
                } else if (percentage > 80) {
                  color = "#FF7B00";
                } else {
                  color = "#FF1800";
                }
                return <span style={{ color }}>{params.value}%</span>;
              },
            };
          } else if (field === "over_under") {
            return {
              field,
              headerName,
              flex: 1,
              renderCell: (params) => {
                const value = parseFloat(params.value);
                let color = value < 0 ? "red" : "green";
                return <span style={{ color }}>{params.value}</span>;
              },
            };
          } else if (field === "a_total") {
            return {
              field,
              headerName,
              flex: 1,
              renderCell: (params) => <span>${params.value}</span>,
            };
          }
          return { field, headerName, flex: 0.5 };
        });

        // Add unique ID to each object dynamically
        const formattedData = data?.weekly_report.map((item, index) => ({
          id: index + 1, // Assigns a unique ID (1, 2, 3, etc.)
          ...item
        }));
        setReport(report)
        setReportRow(formattedData)


      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  // singlr user name 
  const handleClickView = (id, name) => {
    navigate('/timesheet', { state: { initial: id, name: name } });
  };

  const handleSubmit = () => {
    if (selectedFile) {
      const addmemberApi = async () => {
        setIsloading(true)
        const input_token = userID + 'UPLOAD_TIME_SHEET';
        const apiUrl = 'upload_timesheet';
        // Create a FormData object
        const formDataToSend = new FormData();
        formDataToSend.append('login_user_id', userID);
        formDataToSend.append('file', selectedFile);

        try {
          const data = await formauthApi(input_token, formDataToSend, apiUrl, token, true);

          if (data && data.success) {
            await Toastmessage(data.message, true);
            if (data.error) {
              setDocumentError(
                `Error: The following users are not available in our system: ` +
                `${data?.error.join(", ")}. Please add these users and upload the necessary documents.`
              );
            } else {
              setOpen(false);
            }
            // handleClose();
            // fetchLocation();
            // fetcYearMonth()
          } else if (data && data.message === 'Token has expired') {
            setIsloading(false)
            dispatch(logout());
            localStorage.removeItem('token');
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else if (data === undefined) {
            setIsloading(false)
            await Toastmessage('No response from server', false);
          } else {
            setIsloading(false)
            await Toastmessage(data?.message || 'An error occurred', false);
          }
        } catch (error) {
          setIsloading(false)
          console.error("Error fetching data:", error);
          if (error.response && error.response.status === 401) {
            dispatch(logout());
            localStorage.removeItem('token');
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else {
            await Toastmessage('Something went wrong', false);
          }
        }
      };

      addmemberApi()
    }

  };

  // Function to generate dynamic data (You can replace this with your API data)
  const generateDynamicData = (labels, data) => {
    setChartData({
      labels: labels,
      datasets: [
        {
          label: '% Complete',
          data: data,
          borderColor: 'orange',
          backgroundColor: 'rgba(255, 165, 0, 0.2)',
          fill: true,
          tension: 0.4,
        },
      ],
    });
  };

  const columns = [
    { field: 'date', headerName: 'Week Range', flex: 2 },
    {
      field: 'actual_billable_dollars',
      headerName: 'Billable Dollars',
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
    },
    {
      field: 'target_billable',
      headerName: 'Target Billable',
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
    },
    {
      field: 'over_under',
      headerName: 'Over/Under',
      flex: 1,
      renderCell: (params) => {
        const value = parseFloat(params.value);
        let color = value >= 0 ? 'green' : 'red'; // Green for positive, Red for negative
        const sign = value >= 0 ? '+' : ''; // Display "+" for positive numbers

        return (
          <span style={{ color }}>
            {sign}${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        );
      }
    },
    {
      field: 'percent_complete',
      headerName: '% Complete',
      flex: 1,
      renderCell: (params) => {
        const percentage = parseFloat(params.value);
        let color = 'green';
        if (percentage < 80) {
          color = 'red';
        } else if (percentage < 90) {
          color = 'orange';
        }
        return <span style={{ color }}>{params.value}%</span>;
      }
    }
  ];



  return (
    <Box className="scorecard-container">

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <CircumIcon name="percent" tyle={{ marginRight: 8, fontSize: '15px', color: 'var(--icon-color)' }} />
          <Typography fontSize={15} color="var(--text-color)">
            Legal Team Weekly Performance Summary
          </Typography>
        </Box>

        <Box>

          <Button
            // variant="outlined"
            // sx={{
            //   padding: '15px 30px',
            //   borderRadius: '8px',
            //   marginRight: '10px',
            //   backgroundColor: 'var(--primary-color)',
            //   color: '#fff',
            //   '&:hover': { backgroundColor: 'var(--primary-color)' }
            // }}
            className="btn-theme-button"
            startIcon={<Upload size={20} />}
            style={{ textTransform: 'none' }}
            onClick={handleClickOpen}
          >
            Import File
          </Button>
        </Box>
      </Box>

      <Grid container spacing={4} sx={{ px: 2 }}>
        <Grid size={{ md: 3, xs: 12 }}>
          <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Location</Typography>
          <FormControl fullWidth>
            <Autocomplete
              options={locationOption}
              getOptionLabel={(option) => option.locationname}
              value={locationName}
              onChange={(event, newValue) => setLocationName(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select location"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                  }}
                />
              )}
              sx={{ width: '100%' }}
            />
          </FormControl>
        </Grid>

        <Grid size={{ md: 3, xs: 12 }}>
          <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Month & Year</Typography>
          <FormControl fullWidth>

            <Autocomplete
              options={monthYearOption} // Array of month-year strings
              value={monthYear} // Value is a string
              onChange={(event, newValue) => setMonthYear(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select month & year"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                  }}
                />
              )}
              sx={{ width: '100%' }}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ marginTop: '20px', pl: 2, pr: 2 }}>
        <Grid size={{ md: 7, sx: 6 }}>
          <DataGrid
            sx={{ width: '100%' }}
            rows={rows}
            columns={columns}
            className="data-grid"
            hideFooter
            autoHeight
            disableSelectionOnClick
          />
        </Grid>
        <Grid size={{ md: 5, sx: 6 }}>
          <Box
            sx={{
              backgroundColor: 'var(--chart-bg)',
              padding: '10px 20px',
              borderRadius: '0px',
              border: '1px solid var(--chart-border)',
              marginBottom: '24px',
              borderRadius: '8px',
              boxShadow: '0px 1.076px 3.229px 0px rgba(24, 29, 37, 0.10)',
              width: '100%'
            }}
          >
            <h2>Weekly Performance</h2>
            <Line data={chartData} sx={{ width: '100%' }} />
          </Box>
        </Grid>

      </Grid>

      <Grid container spacing={3} sx={{ marginTop: '20px', pl: 2, pr: 2 }}>
        <Grid size={12}>
          <DataGrid
            rows={reportRow} // Render filtered rows
            columns={report}
            pageSize={5}
            autoHeight
            pagination
            hideFooter
            disableSelectionOnClick
            rowsPerPageOptions={[]}
            className="data-grid"
            sx={{ width: '100%' }}
          />
        </Grid>
      </Grid>


      {/* File upload  */}
      <Dialog open={open} onClose={handleClose}>
        {documentError ? (
          <>
            <DialogContent>
              <div>
                <Typography variant="h6" sx={{ textAlign: 'center', color: 'red', fontSize: '12px', fontWeight: 'normal' }}>
                  {documentError}
                </Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">Cancel</Button>
              <Button onClick={Reupload} color="primary">Reupload</Button>
            </DialogActions>
          </>

        ) : (

          <>
            <DialogContent>
              <div
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: dragOver ? '2px solid #000' : '2px dashed #ccc',
                  borderRadius: '8px',
                  padding: '20px',
                  textAlign: 'center',
                  color: '#888',
                  position: 'relative',
                  backgroundColor: dragOver ? '#f0f0f0' : '#fff',
                  width: "528px",
                  height: "303px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    opacity: 0,
                    cursor: 'pointer',
                    top: "0px",
                    right: "0px",
                  }}
                  onChange={handleFileChange}
                />
                <p>Drag and drop an Excel file here or click</p>
                <Upload style={{ fontSize: 40, color: '#888' }} />
              </div>
              {error && <Alert severity="error" style={{ marginTop: '20px' }}>{error}</Alert>}
              {selectedFile && (
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  <p>Uploaded Document: <span sx={{ color: '#000', fontSize: '14px' }}>{selectedFile.name} </span> <Button onClick={handleRemove} color="secondary">Remove</Button></p>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">Cancel</Button>
              <Button onClick={handleSubmit} disabled={isLoading} color="primary">Submit</Button>
            </DialogActions>

          </>

        )}

      </Dialog>

    </Box>
  );
}
